module.exports = __webpack_public_path__ + "static/media/flag.f7f28428.svg";